/**
 * Arche wrapper for Plugin Builder — handles sub-routing with layout variations:
 * - /:sessionId — full-screen plugin editor (no sidebar)
 * - / — wrapped in ArcheLayout (browsing/listing page)
 */

import { Routes, Route } from 'react-router-dom';
import { Header } from '@/components/Header';
import { PluginBuilderPage } from './PluginBuilderPage';
import { PluginSessionsListPage } from './PluginSessionsListPage';

export function PluginBuilderArchePage() {
  return (
    <Routes>
      {/* Plugin editor — full-screen, no sidebar */}
      <Route path="/:sessionId" element={<PluginBuilderPage />} />
      {/* Sessions list — header only, no sidebar */}
      <Route
        path="/*"
        element={
          <div className="flex flex-col h-screen">
            <Header />
            <main className="flex-1 overflow-auto">
              <Routes>
                <Route path="/" element={<PluginSessionsListPage />} />
              </Routes>
            </main>
          </div>
        }
      />
    </Routes>
  );
}
